import React, { Component } from 'react';
import { routerActions } from 'connected-react-router';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Table, Button } from 'semantic-ui-react';
import * as Staff from '../../store/Staff';
import RefreshButton from '../../components/RefreshButton';
class StaffList extends Component {
    constructor(props) {
        super(props);
        
        this.onAddClick = this.onAddClick.bind(this);
        this.onEditClick = this.onEditClick.bind(this);
    }

    onAddClick(e) {
        const {actions} = this.props;
        actions.push('/admin/staff/add');
    }

    onEditClick(e, {data}){
        const {actions} = this.props;
        actions.push(`/admin/staff/${data}`);
    }
    render() {
        const {staff, actions} = this.props;
        return (
            <div>
                <Table>
                    <Table.Header>
                        <Table.Row>
                            <Table.HeaderCell colSpan={2} textAlign="center">Staff</Table.HeaderCell>
                            <Table.HeaderCell><RefreshButton floated="right" action={async () => await actions.getStaff()} /></Table.HeaderCell>
                        </Table.Row>
                    </Table.Header>
                    <Table.Body>
                        {Object.values(staff.staff).map((f, index) => (
                            <Table.Row>
                                <Table.Cell width="1"><Button content="edit" data={f.id} onClick={this.onEditClick} /></Table.Cell>
                                <Table.Cell>{`${f.firstName} ${f.lastName}`}</Table.Cell>
                                <Table.Cell>{f.email}</Table.Cell>
                            </Table.Row>
                        ))}
                    </Table.Body>
                    <Table.Footer>
                        <Table.Row>
                            <Table.HeaderCell colSpan={3}>
                                <Button content="Add" onClick={this.onAddClick} />
                            </Table.HeaderCell>
                        </Table.Row>
                    </Table.Footer>
                </Table>
            </div>
        );
    }
}

StaffList.propTypes = {

};


const mapStateToProps = (state, ownProps) => {
    return {
        staff: Staff.selector(state)
    }
}

const mapDispatchToProps = (dispatch) => ({
    actions: {
        ...bindActionCreators(Staff.actionCreators, dispatch),
        ...bindActionCreators(routerActions, dispatch),
    }
})

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(StaffList));